import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { ValidationModule } from 'rev-shared/util/directives/form/validation/Validation.AngularModule';

import { AddPollButtonComponent } from './AddPollButton.Component';
import { PollInputComponent } from './PollInput.Component';

const declarations = [
	AddPollButtonComponent,
	PollInputComponent
];

@NgModule({
	declarations,
	exports: declarations,
	imports: [
		ButtonsAngularModule,
		CommonModule,
		FormGroupAngularModule,
		FormsModule,
		NgxTrimDirectiveModule,
		TranslateModule,
		ValidationAngularModule,
		ValidationModule
	]
})
export class PollsModule {}
